import React, { Component } from "react"
import { TableDistratosDigitalizadosTrash } from "./"
import Layout from "../../Layout"
import Moment from "moment"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Util from "../../../Util"
export default class DistratosDigitalizadosTrash extends Component {
  constructor() {
    super()
    this.getDistratosDigitalizados = this.getDistratosDigitalizados.bind(this)
    this.filter = this.filter.bind(this)
    this.state = {
      distratosDigitalizados: [],
      initialDistratosDigitalizados: [],
      showTable: false
    }
  }
  componentWillMount() {
    this.getDistratosDigitalizados()
  }
  getDistratosDigitalizados() {
    ApiHelper.getDistratosDigitalizadosTrash(
      this.props.match.params.id,
      (distratosDigitalizados, error) => {
        if (distratosDigitalizados) {
          this.setState({
            distratosDigitalizados: distratosDigitalizados,
            initialDistratosDigitalizados: distratosDigitalizados,
            showTable: true
          })
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialDistratosDigitalizados.filter(distrato => {
      return (
        Util.getLastPathComponent(distrato.nome)
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(distrato.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      distratosDigitalizados: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Distratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Distratos">
        {this.state.showTable ? (
          <TableDistratosDigitalizadosTrash
            filter={this.filter}
            onRestore={this.getDistratosDigitalizados}
            sizeClass=""
            title="Distratos digitalizados deletados"
            subtitle="Listagem de todos os distratos digitalizados que foram deletados"
            backgroundColor="as-blue"
            rows={this.state.distratosDigitalizados}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/distratos/digitalizados/DistratosDigitalizadosTrash.js